/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import {
  defaultTrackMetadata,
  defaultSelect,
} from "../../../../components/tracks/all-tracks/constants";
import { T_TrackMetadata } from "@type/global.types";
import { TrackMetadataForm } from "../../../../components/tracks/all-tracks/TrackMetaData";
import { CloseOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { friendlyTimeBySecond } from "../../../../utils";

export const UploadTrack: React.FC<any> = (props) => {
  let { data, discId, handleTrackDelete, track_Id, setData } = props;
  let datafilter = data.filter((item: any) => item.id == discId);
  const [isFormDisabled, setFormDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<T_TrackMetadata>({
    ...defaultTrackMetadata,
    genre: defaultSelect.number,
    subGenre: defaultSelect.number,
    trackType: defaultSelect.string,
    titleLanguage: defaultSelect.number,
    mood: defaultSelect.number,
  });
  const [expandedSections, setExpandedSections] = useState<number[]>([]);

  const toggleSection = (index: number) => {
    if (expandedSections.includes(index)) {
      setExpandedSections(expandedSections.filter((i) => i !== index));
    } else {
      setExpandedSections([...expandedSections, index]);
    }
  };

  const onChangeFormData = (data: T_TrackMetadata) => {
    setFormData({ ...data });
  };

  datafilter.length > 0 &&
    (datafilter[0].tracks = datafilter[0].tracks.map((item: any) => ({
      ...item,
      trackPart: item?.part || "",
      trackTitle: item?.track_title || "",
      trackType: item?.track_type || "",
      genre: item?.genre_title || "",
      subGenre: item?.fm_subgenre_name || "",
      releaseDate: item?.release_date || "",
      distributionTerr: item?.distribution || "",
    })));

  const moveItemUp = (discId: number, trackIndex: number) => {
    const discIndex = data.findIndex((disc: any) => disc.id === discId);
    if (discIndex !== -1 && trackIndex > 0) {
      const updatedData = [...data];
      const temp = updatedData[discIndex].tracks[trackIndex];
      updatedData[discIndex].tracks[trackIndex] =
        updatedData[discIndex].tracks[trackIndex - 1];
      updatedData[discIndex].tracks[trackIndex - 1] = temp;
      setData(updatedData);
    }
  };

  const moveItemDown = (discId: number, trackIndex: number) => {
    const discIndex = data.findIndex((disc: any) => disc.id === discId);
    if (discIndex !== -1 && trackIndex < datafilter[0].tracks.length - 1) {
      const updatedData = [...data];
      const temp = updatedData[discIndex].tracks[trackIndex];
      updatedData[discIndex].tracks[trackIndex] =
        updatedData[discIndex].tracks[trackIndex + 1];
      updatedData[discIndex].tracks[trackIndex + 1] = temp;
      setData(updatedData);
    }
  };

  return (
    <div className="page-new-track ">
      {datafilter.length > 0 &&
        datafilter[0]?.tracks.map((item: any, index: number) => {
          const isExpanded = expandedSections.includes(index);
          track_Id = index;
          return (
            <div key={index} style={{ borderBottom: "1px solid #ddd" }}>
              <div className=" tw-py-4 tw-w-[calc(70%)] flex ">
                <div
                  className="tw-w-[calc(100%)] tw-bg-blue tw-ml-[50px] tw-leading-1 tw-p-3"
                  style={{ lineHeight: 0.8 }}
                  onClick={() => toggleSection(index)}
                >
                  <p>Track #{index + 1}</p>
                  {item.trackTitle && <p>Title : {item.trackTitle}</p>}
                  {item.track_time && <p> Duration : {friendlyTimeBySecond(item.track_time / 1000)} </p>}
                  {item.trackPart && <p> TrackPart : {item.trackPart}</p>}
                  {item.composer && <p> Composer : {item.composer}</p>}
                  {item.primart_title && <p> Artist : {item.primart_title}</p>}
                </div>
                <div className="tw-mx-1 flex flex-column ">
                  <div
                    className="tw-m-1 tw-cursor-pointer flex justify-center items-center w-30 h-30 tw-p-3 tw-bg-blue"
                    onClick={() => moveItemUp(discId, index)}
                  >
                    <UpOutlined />
                  </div>
                  <div
                    className="tw-m-1 tw-cursor-pointer flex justify-center items-center w-30 h-30 tw-p-3 tw-bg-blue"
                    onClick={() => handleTrackDelete(discId, item.id)}
                  >
                    <CloseOutlined />
                  </div>
                  <div
                    className="  tw-m-1 tw-cursor-pointer flex justify-center items-center w-30 h-30  tw-p-3 tw-bg-blue"
                    onClick={() => moveItemDown(discId, index)}
                  >
                    <DownOutlined />
                  </div>
                </div>
              </div>
              {isExpanded && (
                <TrackMetadataForm
                  formData={{
                    type: "meta-data",
                    data: item,
                  }}
                  disabled={isFormDisabled}
                  setFormData={onChangeFormData}
                />
              )}
            </div>
          );
        })}
    </div>
  );
};

export default UploadTrack;
